import { formatNumber } from './formatNumber';

export const filterRooms = (rooms: { name: string; area: number }[]) =>
  rooms.map(({ name, area }) => ({
    name: `${name}:`,
    value: `${formatNumber(area)} m<sup>2</sup>`,
  }));
